<template>
<div class="nav">
        <ul>
            <li><a hhref="https://huangyao.cn" class="wzatool_txt_flag"><img class="logo" src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-01/1630494943264.png?Expires=1945854934&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=sz%2B9w%2FCodWSWSn7jl0WRHjGbZJU%3D" alt=""></a></li>
            <li id="2">
                <a href="javascript:goFirstPage('https://huangyao.cn','2')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">首页</span></a>
            </li>
            <li id="126">
                <a href="javascript:goFirstPage('','126')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">资讯</span></a>
                <div class="child-nav" style="z-index: 9999">
                    <div>
                        <div class="title">
                            <h1 class="wzatool_txt_flag">资讯</h1>
                            <h2></h2>
                        </div>
                        <ul>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=90&amp;menuId=155" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-16/1634374458786.jpg?Expires=1949734451&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=jq%2FnqPx7a6JpRZOy3kFmjlIhiQQ%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">黄姚资讯</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=87&amp;menuId=154" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2026-06-06/1780736365304.jpg?Expires=2096096365&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=XnsxU6375IUN44PXo%2BItGGaXqX0%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">景区提升</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=86&amp;menuId=153" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-16/1634374456116.jpg?Expires=1949734451&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=%2BOGi2c%2FfemjJ3mSiz7a%2B1%2FhEQcE%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">景区公告</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            <li id="120">
                <a href="javascript:goFirstPage('','120')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">印象</span></a>
                <div class="child-nav" style="z-index: 9999">
                    <div>
                        <div class="title">
                            <h1 class="wzatool_txt_flag">印象</h1>
                            <h2></h2>
                        </div>
                        <ul>
                            <li>
                                <a href="https://huangyao.cn/pageTemplate.html?webPageId=136&amp;menuId=278" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-11/1633945844921.jpg?Expires=1949305843&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=Pfy2CpgQKr5PsFOMSJ3CLJEXZXs%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">黄姚荣誉</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=125&amp;menuId=257" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-20/1632145775375.jpg?Expires=1947505772&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=aPAGHYPGbSzqeYgkSFXuZkBmZcQ%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">红色文化</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=101&amp;menuId=129" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-06/1630920012093.jpg?Expires=1946280024&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=N71u43Pp%2FAkUL%2BhyAEReaCTZ9IQ%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">非遗系列</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=103&amp;menuId=128" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-08/1633680155361.jpg?Expires=1949040155&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=OqIYeYknaSIyEWmXCGnsx52qMTs%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">研学体验</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=102&amp;menuId=127" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-08/1631070898164.jpg?Expires=1947644244&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=P%2BsvXTg277ZevVNmwgf8zi4KSQc%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">民间传说</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=82&amp;menuId=130" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-01/1630490539121.jpg?Expires=1945850532&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=9j5f4pwp4J6NcCFSYAM83yBXHio%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">民俗节庆</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=127&amp;menuId=262" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-12/1634035960761.jpg?Expires=1949395959&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=MBvmd0kABNEBdoXsGIj9oOT98So%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">楹联牌匾</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=132&amp;menuId=267" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-14/1634181514292.jpg?Expires=1949541514&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=ZnyoYyeslKcH5mf2aPfY6h%2BvU64%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">宗祠文化</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=133&amp;menuId=271" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-12/1634011200910.png?Expires=1949371194&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=6NVYqgbyrD9X2Ty4QW%2BPNZEXCM0%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">文学作品</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=137&amp;menuId=275" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-08/1633684048440.jpg?Expires=1949044041&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=bt1EfvV72GDF7Ghr5X9cM%2FzpRBs%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">体育赛事</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            <li id="123">
                <a href="javascript:goFirstPage('','123')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">预订</span></a>
                <div class="child-nav" style="z-index: 9999">
                    <div>
                        <div class="title">
                            <h1 class="wzatool_txt_flag">预订</h1>
                            <h2></h2>
                        </div>
                        <ul>
                            <li>
                                <a href="http://shop.huangyao.cn/ticketDetail" target="_blank" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-11/1633942271743.jpg?Expires=1949302270&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=dKKGlzNaHmU7ququBTHlnqwsTvk%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">门票预订</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="http://shop.huangyao.cn/guideDetail" target="_blank" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2026-06-30/1782788934146.jpg?Expires=2098148931&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=GAuSscHpaoE3t38QpJk8LFS7DKo%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">导游预约</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="http://shop.huangyao.cn/hotel" target="_blank" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-06/1630913661240.jpg?Expires=1946273687&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=jS2o4OlwbWYKbPOWzgZ15QMOreU%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">酒店预订</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="http://shop.huangyao.cn/shop" target="_blank" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-19/1634608895997.jpg?Expires=1949968895&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=hJyPEsbtFk9VGOrSgYBjEBZwFrM%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">产品抢购</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            <li id="196">
                <a href="javascript:goFirstPage('','196')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">交通</span></a>
                <div class="child-nav" style="z-index: 9999">
                    <div>
                        <div class="title">
                            <h1 class="wzatool_txt_flag">交通</h1>
                            <h2></h2>
                        </div>
                        <ul>
                            <li>
                                <a href="https://huangyao.cn/articleDetail.html?articleId=237&amp;columnId=38&amp;menuId=266" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-23/1632387977292.png?Expires=1950157217&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=Jj%2FQJkBRz2fKR3hU9W1rKJpJLUY%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">交通指南</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            <li id="202">
                <a href="javascript:goFirstPage('','202')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">游玩</span></a>
                <div class="child-nav" style="z-index: 9999">
                    <div>
                        <div class="title">
                            <h1 class="wzatool_txt_flag">游玩</h1>
                            <h2></h2>
                        </div>
                        <ul>
                            <li>
                                <a href="https://huangyao.cn/pageTemplate.html?webPageId=91&amp;menuId=203" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-27/1635344811793.jpg?Expires=1950704810&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=7AXyYHt8tFcl8zIM79eMjc9nSTQ%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">概况</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=96&amp;menuId=204" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-11/1633942271743.jpg?Expires=1949302270&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=dKKGlzNaHmU7ququBTHlnqwsTvk%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">景点</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/pageTemplate.html?webPageId=131&amp;menuId=205" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-27/1635344818811.jpg?Expires=1950704810&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=DnuodW3huLrUdGfMbL5SCOVtKRU%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">路线</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=112&amp;menuId=206" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-08/1631069276820.jpg?Expires=1946429277&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=v1KSQ9xAwjdRmggqSezOfonEgks%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">攻略</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/poi.html" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-27/1635344815791.jpg?Expires=1950704810&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=5RFJDLu05aJoE01Rj2C4R95Hnak%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">导航导览</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a hhref="https://vr.huangyao.cn" target="_blank" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-15/1631696999984.png?Expires=1947056996&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=5V2BVPsybRpijrkcbymriDYbM3Q%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">VR全景导览</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=116&amp;menuId=223" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-26/1632625744004.jpg?Expires=1947985738&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=vZIiNyG%2B%2B8tWweM4CwHLhOmAg4U%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">周边景区</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleDetail.html?articleId=696&amp;columnId=5&amp;menuId=286" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2026-05-22/1779419169464.png?Expires=2094779174&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=A8G%2FDUT7F78Xqp2DeVofcAi5A7s%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">名木古树</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleDetail.html?articleId=697&amp;columnId=5&amp;menuId=288" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2026-05-23/1779505366866.png?Expires=2094865362&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=OeVoK2lzwllw4Kr%2FMcdm7OKRpbo%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">文物清单</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            <li id="209">
                <a href="javascript:goFirstPage('','209')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">住宿</span></a>
                <div class="child-nav" style="z-index: 9999">
                    <div>
                        <div class="title">
                            <h1 class="wzatool_txt_flag">住宿</h1>
                            <h2></h2>
                        </div>
                        <ul>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=92&amp;menuId=210" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-06/1630913298847.jpg?Expires=1946273329&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=XAEvnf%2BzhEH5Wup6oTEc6JfTfg4%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">酒店</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=93&amp;menuId=211" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-22/1632269208056.jpg?Expires=1947629202&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=Xjg0nVXoOj6tgISnISODW3nd2Qc%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">民宿</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            <li id="212">
                <a href="javascript:goFirstPage('','212')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">美食</span></a>
                <div class="child-nav" style="z-index: 9999">
                    <div>
                        <div class="title">
                            <h1 class="wzatool_txt_flag">美食</h1>
                            <h2></h2>
                        </div>
                        <ul>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=98&amp;menuId=214" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-08/1633703186437.jpg?Expires=1949063184&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=6Xcrz1yXWKUFjJTpaA51PLaGlDc%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">美滋美味</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=99&amp;menuId=215" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-23/1632386354593.png?Expires=1947746355&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=3cLDyL1iuvgZY09p6Bb8ulf5d20%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">特色餐飲</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            <li id="216">
                <a href="javascript:goFirstPage('','216')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">购物</span></a>
                <div class="child-nav" style="z-index: 9999">
                    <div>
                        <div class="title">
                            <h1 class="wzatool_txt_flag">购物</h1>
                            <h2></h2>
                        </div>
                        <ul>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=94&amp;menuId=218" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-06/1630915149086.jpg?Expires=1946275151&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=mpBScDGf0rbOFp0h36o%2BOcm4Bn8%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">特色购物</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=95&amp;menuId=217" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-09-26/1632626235891.jpg?Expires=1947986235&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=xG6A74tZ4ArYxOcJ8ZtlCIpQOQc%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">文创产品</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            <li id="219">
                <a href="javascript:goFirstPage('','219')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">娱乐</span></a>
                <div class="child-nav" style="z-index: 9999">
                    <div>
                        <div class="title">
                            <h1 class="wzatool_txt_flag">娱乐</h1>
                            <h2></h2>
                        </div>
                        <ul>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=135&amp;menuId=272" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-11/1633953389905.jpg?Expires=1949313386&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=hzpouQVJdqGLgDTnT2EIDY7cmdw%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">黄姚影视</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
            <li id="124">
                <a href="javascript:goFirstPage('','124')" class="wzatool_txt_flag"><span class="nowrapstyle wzatool_txt_flag">服务</span></a>
                <div class="child-nav" style="z-index: 9999">
                    <div>
                        <div class="title">
                            <h1 class="wzatool_txt_flag">服务</h1>
                            <h2></h2>
                        </div>
                        <ul>
                            <li>
                                <a href="https://huangyao.cn/pageTemplate.html?webPageId=111&amp;menuId=142" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-14/1634183141563.jpg?Expires=1949543137&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=N43x7Z01Ntz6A7Ro6szZx15epQ0%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">游客服务</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/pageTemplate.html?webPageId=128&amp;menuId=141" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-14/1634183142407.jpg?Expires=1949543137&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=tmr1pi9Y2jTBZMiyEzvi0SpsS4Q%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">游客须知</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/faq.html?menuId=140" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-14/1634183145892.jpg?Expires=1949543139&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=5%2FEEM9CfH1FH3J6Rd9UnKZucPOA%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">常见问题</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/lostFound.html?menuId=143" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-14/1634183137149.jpg?Expires=1949543137&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=NSJ4duxxuuF%2BGLTiD6MnBLsI4N4%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">失物招领</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/feedback.html?menuId=144" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-10-14/1634183143218.jpg?Expires=1949543137&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=IdAkpozTOvWJGEMaFLUpKXCgE6w%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">意见反馈</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/touristEvaluation.html?menuId=282" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2021-11-02/1635843434328.jpg?Expires=1951203429&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=xzN2ILIxbR8N0vSzAIN4QNJoWHQ%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">游客评价</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                            <li>
                                <a href="https://huangyao.cn/articleTemplate.html?webPageId=151&amp;menuId=289" class="wzatool_txt_flag">
                                    <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/2026-05-26/1779765771989.jpg?Expires=2095125769&amp;OSSAccessKeyId=LTAI4GJxALzftKu6WSo8n4oP&amp;Signature=rw95Evik%2B%2FKm9GR3A%2FWY82YUSIg%3D" alt="">
                                    <p>
                                        <span class="wzatool_txt_flag">资料下载</span>
                                        <img src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_right_black.svg" alt="">
                                    </p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>
           <li><a href="https://huangyao.cn/search.html" class="wzatool_txt_flag"><img class="search-img" src="https://bibi-huangyao.oss-cn-shanghai.aliyuncs.com/static/img/icon/icon_search_black.svg" alt=""></a></li>
        </ul>
    </div>
</template>
<script>
import Login from "./login/login.vue";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { mapState, mapMutations, mapAction } from "vuex";
export default {
  components: { Login },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      token:(state)=>state.token
    }),
  },
  methods: {
    menuCommand(command) {
      let rightShow;
      switch (command) {
        case "homepage":
          rightShow = "myPage";
          this.$router.push({ path: "/myHomePage" });
          break;
        case "order":
          console.log("order");
          rightShow = "ticket";
          this.$router.push({ path: "/myHomePage" });
          break;
        case "address":
          console.log("address");
          rightShow = "address";
          this.$router.push({ path: "/myHomePage" });
          break;
        case "consignee":
          console.log("consignee");
          rightShow = "consignee";
          this.$router.push({ path: "/myHomePage" });
          break;
        case "loginOut":
          this.logout();
          break;
      }
      sessionStorage.setItem("rightShow", rightShow);
    },
    goCart() {
      this.$router.push({
        path: "/shopCart",
      });
    },
    login() {
      // this.$refs.login.open()
      this.$store.commit("SET_SHOW", true);
    },
    logout() {
      this.$confirm("确定退出吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("FedLogOut").then(() => {
          location.href = "/shop";
        });
      });
    },
  },
};
</script>
<style scoped lang='scss'>
  .nav {
    max-width: 1400px;
    min-width: 1200px;
    height: 100px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;

    > ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      > li {
        color: #13253D;
        height: 100px;
        line-height: 100px;
        padding: 0 15px;
        cursor: pointer;
        text-align: center;

        > a {
          color: #13253D;
          text-decoration: none;
          display: inline-block;
          position: relative;
          font-size: 14px;

          &:after {
            content: '';
            display: inline-block;
            width: 100%;
            height: 2px;
            background-color: rgba(0, 0, 0, 0);
            position: absolute;
            left: 0;
            top: 66px;
          }
        }

        .logo {
          width: 270px;
          height: 46px;
          display: block;
          object-fit: contain;
          margin-top: 27px;
        }

        .search-img {
          width: 16px;
          height: 16px;
          display: block;
          object-fit: contain;
          margin-top: 42px;
        }

        .child-nav {
          position: absolute;
          left: 0;
          top: 99px;
          width: 100%;
          background-color: #f8f8f8;
          z-index: 1;
          display: none;

          > div {
            max-width: 1400px;
            min-width: 1200px;
            display: flex;
            min-height: 240px;
            margin: 50px auto 0 auto;

            .title {
              padding-left: 20px;
              min-width: 250px;

              h1 {
                font-size: 30px;
                color: #333333;
                font-weight: 400;
                line-height: 1;
                margin: 0;
              }

              h2 {
                font-size: 18px;
                font-weight: 400;
                color: #333333;
                opacity: 0.5;
                line-height: 1;
                margin: 14px 0;
              }
            }

            > ul {
              width: 100%;
              margin: 0 auto;
              padding: 0;
              display: flex;
              flex-wrap: wrap;
              justify-content: flex-start;

              > li {
                width: 200px;
                text-align: left;
                margin-left: 20px;
                cursor: pointer;

                > a {
                  text-decoration: none;
                  color: #333333;
                }

                &:hover {
                  color: #FFA800;

                  a {
                    color: #FFA800;
                  }

                }

                img {
                  width: 200px;
                  height: 120px;
                  border-radius: 5px;
                  display: block;
                }

                p {
                  margin: 17px 0;
                  padding: 0;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  line-height: 1;
                  font-size: 14px;

                  img {
                    width: 10px;
                    height: 20px;
                    display: block;
                  }
                }
              }

            }
          }
        }


        &:hover,
        &.on {
          > a {
            color: #FFA800;
            display: inline-block;

            &:after {
              display: inline-block;
              background-color: #FFA800;
            }
          }


        }

        &:hover {
          .child-nav {
            display: flex;
          }
        }

        &:nth-of-type(1) {
          flex: 1;
          text-align: left;

          &:hover,
          &.on {
            &:after {
              background-color: rgba(0, 0, 0, 0);
            }
          }
        }

        &:last-of-type,
        &:first-of-type {
          &:hover,
          &.on {
            > a {
              &:after {
                background-color: rgba(0, 0, 0, 0);
              }
            }
          }
        }

      }
    }
  }

</style>